import React from "react";
import PropTypes from "prop-types";

import PtoRequestStatusSelect from "../components/PtoRequestStatusSelect";

const PtoRequestListFilters = ({
  show,
  filters,
  handleSubmit,
  handleChange,
  loading,
  handleReset
}) => {
  const classList = [
    "project-filters",
    "pto-request-filters",
    show ? "is-visible" : ""
  ].join(" ");
  return (
    <div className={classList}>
      <form className="request-filters" onSubmit={handleSubmit}>
        <PtoRequestStatusSelect
          isMulti
          value={filters && filters.status}
          onChange={handleChange("status")}
        />
        <button
          disabled={loading}
          className="btn btn-warning"
          type="button"
          onClick={handleReset}
          style={{ height: 38 }}
        >
          Reset
        </button>
      </form>
    </div>
  );
};

PtoRequestListFilters.propTypes = {
  show: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleReset: PropTypes.func,
  loading: PropTypes.bool,
  filters: PropTypes.array
};
export default PtoRequestListFilters;
